export const faqSection = {
  title: 'Вопросы и ответы',
  items: [
    {
      question: 'Где и когда?',
      answer: [
        'Индустрия ИИ пройдёт 18 июня 2026 года в Новосибирске, Mirotel, Площадь Карла Маркса, 1/1.',
        'Программа мероприятия в подробностях появится на сайте в мае. Спикеры уже публикуются на сайте — список обновляется регулярно.'
      ]
    },
    {
      question: 'Это платно?',
      answer: [
        'Да, участие платное. Доступны несколько форматов участия: Базовый, Бизнес и VIP.',
        'Каждый тариф включает доступ к программе форума, а расширенные тарифы дают дополнительные возможности: лучшие места, приоритетную регистрацию, нетворкинг и закрытые форматы общения.'
      ]
    },
    {
      question: 'Как зарегистрироваться?',
      answer: ['Выберите подходящий тариф на сайте и нажмите кнопку «Купить билет» или «Выбрать тариф».']
    },
    {
      question: 'Оплата частями для физлиц',
      answer: [
        'Да, для физических лиц возможна оплата частями, если такой способ доступен на стороне платёжного сервиса.',
        'При оформлении билета выберите удобный способ оплаты. Если возникнут сложности, напишите организаторам — мы подскажем, как лучше оформить участие.'
      ]
    },
    {
      question: 'Как оплатить юрлицам?',
      answer: [
        'Юридические лица могут оплатить участие по счёту.',
        'Напишите нам на почту или в MAX, укажите количество участников, выбранный тариф и реквизиты компании. Мы подготовим счёт и необходимые документы.'
      ]
    },
    {
      question: 'Как оплатить за коллег одним счётом?',
      answer: [
        'Да, можно оплатить участие нескольких сотрудников одним счётом.',
        'Пришлите список участников, их email-адреса, выбранные тарифы и реквизиты компании. Мы сформируем один общий счёт на оплату.'
      ]
    },
    {
      question: 'Хотим заключить договор, иначе не оплатим',
      answer: [
        'Мы можем подготовить договор для вашей компании.',
        'Напишите организаторам, укажите реквизиты, количество участников и выбранные тарифы. После согласования подготовим договор и счёт.'
      ]
    },
    {
      question: 'Скидки на самолёт и проживание',
      answer: [
        'Информация о партнёрских условиях на перелёт и проживание будет опубликована дополнительно.',
        'Если специальные условия появятся, мы добавим их на сайт и сообщим участникам в рассылке или MAX-канале.'
      ]
    },
    {
      question: 'Как стать партнёром? Стенд поставить и вот это всё?',
      answer: [
        'Напишите нам, если хотите представить бренд на форуме.',
        'Мы обсудим подходящий формат: партнёрский пакет, стенд, бренд-зону, выступление, интеграции в коммуникации или другие варианты присутствия на площадке.'
      ]
    },
    {
      question: 'Хочу выступить с докладом',
      answer: [
        'Отправьте тему доклада, краткое описание, информацию о себе и компании.',
        'Программный комитет рассмотрит заявку и свяжется с вами, если тема подойдёт программе форума.'
      ]
    }
  ]
};
